<template>
  <div class="published">
    <div style="margin-bottom: 10px">
      <a-button type="primary" @click="addnewlesson"> 创建新课程 </a-button>
    </div>
    <div style="margin-bottom: 10px">
      <a-row type="flex">
        <a-col :flex="5" v-if="userRole == 'youwei_admin'">
          <span>所属公司：</span>
          <a-tree-select style="width: 160px; margin-right: 10px" v-model="searchInfo.companyId" allowClear
            :treeData="deptLists" :show-checked-strategy="SHOW_PARENT" placeholder="所属公司" :replaceFields="options"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1" @change="deptchange">
          </a-tree-select>
        </a-col>
        <a-col :flex="5">
          <span>课程类别：</span>
          <a-select v-model="searchInfo.trainIds" @change="oncourseTypeChange" showSearch optionFilterProp="label"
            placeholder="请选择" style="width: 160px; margin-right: 10px" allowClear>
            <!-- <a-select-option :value="item.id" :label="item.categoryName" v-for="(item, index) in categoryList"
              :key="index">
              {{ item.categoryName }}
            </a-select-option> -->

            <a-select-option :value="item" :label="index" v-for="(item, index) in categoryList" :key="index">
              {{ index }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :flex="5">
          <span>课程名称：</span>
          <!-- <a-input placeholder="请选择" v-model="searchInfo.courseName" style="width: 160px; margin-right: 10px" /> -->
          <a-select showSearch optionFilterProp="label" v-model="searchInfo.courseName" placeholder="请选择"
            style="width: 160px; margin-right: 10px" allowClear>
            <a-select-option :value="item" :label="item" v-for="item,index in allCourseLis" :key="index">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :flex="5">
          <span>最后操作者：</span>
          <a-input placeholder="请填写" v-model="searchInfo.lastModifier" style="width: 160px; margin-right: 10px" />
        </a-col>
        <a-col :flex="4">
          <a-button type="primary" @click="search_lis"> 查询 </a-button>
          <a-button @click="refresh"> 重置 </a-button>
        </a-col>
      </a-row>
    </div>
    <div style="margin-bottom: 10px; height: calc(100% - 126px)" ref="mainTable">
      <a-table :data-source="data" :scroll="{ y: tableScrollY }" :pagination="false" rowKey="id"
        :rowClassName="rowClass">
        <a-table-column title="所属公司" key="companyId" dataIndex="companyId" v-if="userRole=='youwei_admin'">
          <template slot-scope="text,record">
            {{deptObj[record.companyId].title}}
          </template>
        </a-table-column>
        <a-table-column title="课程类别" key="trainType" dataIndex="trainType"></a-table-column>
        <a-table-column title="课程名称" key="courseName" dataIndex="courseName"></a-table-column>
        <a-table-column title="学时" key="classHour" dataIndex="classHour"></a-table-column>
        <a-table-column title="必修部门" key="deptId" dataIndex="deptId">
          <template slot-scope="text, record">
            <a-dropdown placement="bottomLeft">
              <a-button>{{ deptIds[record.deptId.split(',')[0]]
                }}<template v-if="record.deptId.split(',').length > 1">
                  <a-icon type="caret-down" />
                </template>
              </a-button>
              <a-menu slot="overlay" v-if="record.deptId.split(',').length > 1">
                <a-menu-item v-for="(item, index) in record.deptId.split(',')" :key="index">
                  {{ deptIds[item] }}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table-column>
        <a-table-column title="最后操作者" key="lastModifier" dataIndex="lastModifier"></a-table-column>
        <a-table-column title="最后操作时间" key="updateTime" dataIndex="updateTime"></a-table-column>
        <a-table-column title="操作" key="id" dataIndex="id">
          <template slot-scope="text, record">
            <template v-if="record.issueFlag == 1">
              <a-button type="link" @click="changeInfo(record)"> 编辑 </a-button>
              <a-divider type="vertical" />
              <a-button type="link" @click="changeState(record,2)"> 下架 </a-button>
              <a-divider type="vertical" v-if="userRole=='youwei_admin'" />
              <a-button type="link" @click="copyRow(record)" v-if="userRole=='youwei_admin'"> 分享 </a-button>
              <!-- <a-button type="link" @click="cancelPublish(record)"> 取消发布 </a-button> -->
            </template>
            <template v-if="record.issueFlag == 2">
              <a-button type="link" @click="changeState(record,1)"> 上架 </a-button>
              <a-divider type="vertical" v-if="userRole=='youwei_admin'" />
              <a-button type="link" @click="copyRow(record)" v-if="userRole=='youwei_admin'"> 分享 </a-button>
              <!-- <a-button type="link" @click="cancelPublish(record)"> 取消发布 </a-button> -->
            </template>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <div>
      <a-pagination show-size-changer :default-current="1" :total="totalCount" :page-size.sync="searchInfo.pageSize"
        @change="onShowPageChange" show-quick-jumper />
    </div>
    <a-modal v-model="copyRowShow" title="课程分享" @ok="copyRowSubmit" width="80%">
      <a-form :label-col="{ span: 8 }" v-if="copyRowShow">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item :label="'所属公司'">{{this.deptObj[selectRow.companyId].title}}</a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="'课程类别'">{{selectRow.trainType}}</a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="'课程名称'">{{selectRow.courseName}}</a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-item :label="'必修部门'">
              <a-dropdown placement="bottomLeft" style="width:160px;">
                <a-button>{{ deptIds[selectRow.deptId.split(',')[0]]
                }}<template v-if="selectRow.deptId.split(',').length > 1">
                    <a-icon type="caret-down" />
                  </template>
                </a-button>
                <a-menu slot="overlay" v-if="selectRow.deptId.split(',').length > 1">
                  <a-menu-item v-for="(item, index) in selectRow.deptId.split(',')" :key="index">
                    {{ deptIds[item] }}
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="'学时'">{{selectRow.classHour}}</a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-table :data-source="copyLis" rowKey="companyId" :row-selection="rowSelection" v-if="copyRowShow"
        :pagination="false">
        <a-table-column type="selection"></a-table-column>
        <a-table-column title="所属公司" key="companyId" dataIndex="companyId" width="120px">
          <template slot-scope="text, record">
            {{deptObj[record.companyId].title}}
          </template>
        </a-table-column>
        <a-table-column title="课程类别" key="trainId" dataIndex="trainId">
          <template slot-scope="text, record">
            <a-select v-model="record.trainId" placeholder="课程类别" showSearch optionFilterProp="label"
              style="width:100%;min-width:160px;">
              <a-select-option :value="item.id" v-for="(item, index) in trainIdObj[record.companyId]" :key="index"
                :label="item.categoryName">
                {{ item.categoryName }}
              </a-select-option>
            </a-select>
          </template>
        </a-table-column>
        <a-table-column title="课程名称" key="courseName" dataIndex="courseName">
          <template slot-scope="text, record">
            <a-input placeholder="课程名称" v-model="record.courseName" style="width:100%;min-width:160px;" />
          </template>
        </a-table-column>
        <a-table-column title="必修部门" key="deptId" dataIndex="deptId">
          <template slot-scope="text, record">
            <a-tree-select v-model="record.deptId" allowClear :treeData="deptObj[record.companyId].children"
              style="width:100%;min-width:160px;" tree-checkable :show-checked-strategy="SHOW_PARENT" placeholder="必修部门"
              :replaceFields="options" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1">
            </a-tree-select>
          </template>
        </a-table-column>
        <a-table-column title="学时" key="classHour" dataIndex="classHour">
          <template slot-scope="text, record">
            <a-input type="number" placeholder="学时" v-model="record.classHour" style="width:100%;min-width:160px;" />
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { getCueseLists, changeCueseInfo, getAllCourse, getCategoryLis, changeCourseMarketState, saveCueseInfo } from '../../../api/course'
import { tree_all } from '../../../api/purchase'
export default {
  data() {
    let rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(selectedRows);
        this.copySelect = selectedRows
      },
    };
    return {
      searchInfo: {
        companyId: undefined,
        trainId: undefined, // 课程类别
        trainIds: undefined, // 课程类别
        courseName: undefined, // 课程名称
        lastModifier: '', // 最后操作者
        pageIndex: 1,
        pageSize: 10, // 每页条数
        issueFlag: 1,
      },
      totalCount: 0,
      data: [],
      tableScrollY: '',
      categoryList: [],
      allCourseLis: [],
      deptIds: {},
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
      userInfo: {},
      deptObj: {},
      userRole: '',

      copyRowShow: false,
      selectRow: {},
      copyLis: [],
      trainIdObj: {},
      rowSelection: rowSelection,
      copySelect: []
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == "youwei_admin") {
        this.userRole = 'youwei_admin'
      }
    }
    this.$nextTick((res) => {
      this.tableScrollY = this.$refs.mainTable.offsetHeight - 54
    })
  },
  methods: {
    init() {
      this.getCategoryList()
      this.getAllCourseLis({ trainIds: this.searchInfo.trainIds, issueFlag: 1 })
      this.getDeptLists()
      this.$nextTick((res) => {
        this.tableScrollY = this.$refs.mainTable.offsetHeight - 54
      })
    },
    copyRowSubmit() {
      let request_lis = []
      for (let i = 0; i < this.copySelect.length; i++) {
        if (!this.copySelect[i].trainId || !this.copySelect[i].deptId || !this.copySelect[i].deptId.length || !this.copySelect[i].courseName || !this.copySelect[i].classHour) {
          return this.$message.error('选中行课程类别、课程名称、必修部门、学时为必填')
        }
        request_lis.push(new Promise((resolve, reject) => {
          let params = JSON.parse(JSON.stringify(this.copySelect[i]))
          params.deptId = params.deptId.join(',')
          saveCueseInfo(params).then((res) => {
            if (res.code != 200) {
              reject(this.$message.error(res.msg))
            }
            resolve(res)
          })
        }))
      }
      Promise.all(request_lis).then(res => {
        this.$message.success('添加成功')
        this.copyRowShow = false
        this.$emit('changeTab', true)
      }).catch(err => {
        console.log(err);
      })
    },
    copyRow(row) {
      this.selectRow = row
      let _this = this
      let copyLis = []
      let request_lis = []
      let trainIdObj = {}
      for (let i = 0; i < this.deptLists.length; i++) {
        if (row.companyId != this.deptLists[i].deptId) {
          copyLis.push(
            {
              companyId: this.deptLists[i].deptId,
              trainId: undefined,
              courseName: row.courseName,
              deptId: [],
              classHour: row.classHour,
              md5: row.md5,
            }
          )
          request_lis.push(new Promise((resolve, reject) => {
            getCategoryLis({ companyId: this.deptLists[i].deptId }).then((res) => {
              if (res.code != 200) {
                reject(res.msg)
              }
              trainIdObj[this.deptLists[i].deptId] = res.data.list
              resolve(res.data.list)
            })
          }))
        }
      }
      Promise.all(request_lis).then(res => {
        this.trainIdObj = trainIdObj
        console.log(trainIdObj);
        this.copyLis = copyLis
        this.copyRowShow = true
      }).catch(res => {
        this.$message.error(res)
      })
    },
    deptchange() {
      this.searchInfo.trainId = undefined
      this.searchInfo.courseName = undefined
      this.searchInfo.trainIds = undefined
      this.getCategoryList(this.searchInfo.companyId)
    },
    rowClass(record, index) {
      if (record.issueFlag == 2) {
        return 'grayRow'
      }
      return ''
    },
    changeState(row, type) {
      let text = '是否确认' + (type == 1 ? '上架？' : '下架？')
      this.$confirm({
        title: '提示',
        content: text,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          changeCourseMarketState({
            id: row.id,
            issueFlag: type,
          }).then((res) => {
            if (res.code != 200) {
              return this.$message.error(res.msg)
            }
            this.$message.success((type == 1 ? '上架' : '下架') + '成功')
            this.get_lis()
          })
        },
        onCancel: () => {

        }
      })
    },
    childDipt(lists) {
      for (let i = 0; i < lists.length; i++) {
        lists.forEach((item) => {
          if (!item.children.length) {
            this.deptIds[item.deptId] = item.title
          } else {
            this.childDipt(item.children)
          }
        })
      }
    },
    getDeptLists() {
      let _this = this
      tree_all().then((res) => {
        this.childDipt(res.data[0])
        let deptObj = {}
        if (this.userRole == "youwei_admin") {
          let data = res.data[0]
          for (let i = 0; i < data.length; i++) {
            deptObj[data[i].deptId] = data[i]
          }
          this.deptObj = JSON.parse(JSON.stringify(deptObj))
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (!_this.userInfo.userPermissions.includes(lists[i].deptId) && !_this.userInfo.userPermissions.includes(String(lists[i].deptId))) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                delete lists[i].children
              }
            }
          }
          formatDept(data)
          this.deptLists = data
        } else {
          this.deptLists = res.data[0]
        }
        this.$nextTick((res) => {
          this.get_lis()
        })
      })
    },
    changeInfo(row) {
      this.$router.push({
        path: '/training/course/addcourse?select=1&id=' + row.id,
      })
    },
    oncourseTypeChange() {
      this.searchInfo.courseName = undefined
      this.getAllCourseLis({ trainIds: this.searchInfo.trainIds, issueFlag: 1 })
    },
    getCategoryList(companyId) {
      getCategoryLis({ companyId: companyId }).then((res) => {
        if (res.code != 200) {
          return
        }
        let categoryList = {}
        for (let i = 0; i < res.data.list.length; i++) {
          if (!categoryList[res.data.list[i].categoryName]) {
            categoryList[res.data.list[i].categoryName] = res.data.list[i].id
          } else {
            categoryList[res.data.list[i].categoryName] += ',' + res.data.list[i].id
          }
        }
        this.categoryList = categoryList
      })
    },
    getAllCourseLis(params) {
      getCueseLists(params).then((res) => {
        if (res.code != 200) {
          return
        }
        let allCourseLis = []
        for (let i = 0; i < res.data.list.length; i++) {
          if (!allCourseLis.includes(res.data.list[i].courseName)) {
            allCourseLis.push(res.data.list[i].courseName)
          }
        }
        this.allCourseLis = allCourseLis
      })
    },
    search_lis() {
      this.searchInfo.pageIndex = 1
      this.get_lis()
    },
    refresh() {
      this.searchInfo = {
        companyId: undefined,
        trainId: undefined, // 课程类别
        courseName: undefined, // 课程名称
        lastModifier: undefined, // 最后操作者
        pageIndex: 1,
        pageSize: 10, // 每页条数
        issueFlag: 1,
      }
      this.get_lis()
      this.getAllCourseLis('')
    },
    cancelPublish(row) {
      let _this = this
      this.$confirm({
        title: '提示',
        content: '是否确认取消发布?',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          changeCueseInfo({
            id: row.id,
            issueFlag: 0,
          }).then((res) => {
            if (res.code != 200) {
              return _this.$message.error(res.msg)
            }
            _this.$message.success('取消发布成功')
            _this.get_lis()
          })
        },
        onCancel() {
          _this.$message.info('已取消操作')
        },
      })
    },
    get_lis() {
      getCueseLists(this.searchInfo).then((res) => {
        if (res.code != 200) {
          return
        }
        this.data = res.data.list
        this.totalCount = res.data.totalCount
      })
    },
    addnewlesson() {
      this.$router.push({
        path: '/training/course/addcourse?select=2',
      })
    },
    onShowPageChange(page, pageSize) {
      this.searchInfo.pageIndex = page
      this.get_lis()
    },
  },
}
</script>

<style scoped lang="less">
.published {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  /deep/ .ant-btn-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  /deep/ .ant-divider {
    background: #1890ff;
  }

  /deep/ .ant-dropdown-trigger {
    padding-left: 0 !important;
    padding-right: 0 !important;
    border: 0;
    background: transparent;
  }
  /deep/ .grayRow {
    background: #eee;
  }
}
</style>